/** @file Flow types for Units */

import type { ServerDevice } from '../Devices/types';
import type { Address } from '../types';

export type PipeDiameter = 0.75 | 1;

export type ServerPipeDiameter = '3_4INCH' | '1INCH';

export type PipeMaterial = 'COPPER-M' | 'COPPER-L' | 'PVC' | 'CPVC' | 'PEX' | 'n/a';

export type UnitPmsConfig = {
  unit_name?: string;
  unit_id?: number;
};

/**
 * Per-unit setting controlling the daily usage bar chart on generated custom
 * invoice PDFs. Mirrors `UsageGraphMode` in `ssw_common`. Stored as an integer
 * so additional modes can be added without a schema change.
 */
export const UsageGraphMode = {
  HIDDEN: 0,
  INCLUDED: 1,
} as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare -- const + same-name type is the canonical TS enum-like pattern
export type UsageGraphMode = (typeof UsageGraphMode)[keyof typeof UsageGraphMode];

export type ServerUnit = {
  id: string;
  address: Address;
  index: number;
  name: string;
  pipe_diameter: '1INCH' | '3_4INCH';
  pipe_material: PipeMaterial;
  structure_id: string;
  devices: ServerDevice[];
  unit_flags: ('NON_BILLABLE' | 'COMMON_AREA' | 'SPLIT')[];
  pms_type?: string | null;
  pms_config?: UnitPmsConfig | null;
  /** Per-unit usage-graph display setting. See {@link UsageGraphMode}. */
  usage_graph_mode?: UsageGraphMode;
};

export type Unit = {
  id: string;
  address: Address;
  index: number;
  name: string;
  deviceIds: string[];
  devices: ServerDevice[];
  unit_flags: ('NON_BILLABLE' | 'COMMON_AREA' | 'SPLIT')[];
  pms_type?: string | null;
  pms_config?: UnitPmsConfig | null;
  /** Per-unit usage-graph display setting. See {@link UsageGraphMode}. */
  usage_graph_mode?: UsageGraphMode;
};

export interface AddUnitFormValues {
  name: string;
  pipeDiameter: PipeDiameter;
  pipeMaterial: PipeMaterial;
  unitFlag?: ('NON_BILLABLE' | 'COMMON_AREA' | 'SPLIT')[];
}
